// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-app--wrap{max-width:100%;min-height:100vh}.v-app--no-drawer .v-header{left:0}.v-app--no-drawer .v-main{padding-left:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
